import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { closeHelp } from '../../state/actions/modal';
import { CloseHelp } from '../stateless/buttons';

/**
 * @class Modal
 *
 * @description
 * Class for a showing a modal questions on screen.
 *
 * @example
 * <Modal />
 */
@connect(
	state => ({
		isHelpOpen: state.modal.isHelpOpen,
		help: state.setup.help,
		translations: state.setup.translations,
		countryCode: state.user.profileData.countryCode
	}),
	dispatch => ({
		closeHelp: () => {
			dispatch(closeHelp());
		}
	})
)
export default class HelpOverlay extends Component {

	static propTypes = {
		transitionKey: PropTypes.string,
		help: PropTypes.object,
	};

	getModalClasses () {
		let classes = 'help-modal';

		if (this.props.isHelpOpen) {
			classes += ' help-modal--active';
		} else {
			classes += ' help-modal--inactive';
		}

		return classes;
	}

	render () {
		const { content, translations, countryCode } = this.props;
		const { heading, paragraph } = this.props.help[content];

		return (
			<div className={this.getModalClasses()}>
				<div className="help-modal__inner">
					<CloseHelp closeHelp={() => this.props.closeHelp} text={translations.close[countryCode]}/>
					<h2>{heading[countryCode]}</h2>
					{
						paragraph.map((element) => <p key={element[countryCode]}>{element[countryCode]}</p>)
					}
				</div>
			</div>
		);
	}
}
